export default __webpack_public_path__ + "static/media/whiteWarning.002d9392.svg";